import { css } from "@emotion/react";

export const shortPickerStyles = css`
  max-width: 300px;
`;
